export default "__VITE_ASSET__e70ab14b__"